import { Component, Input} from '@angular/core';
import { VersionFeedback, ApprovalStatusColorValues, FeedbackStatusColorValues } from '@core/models/version-feedback';

import { VersionShare } from '@core/models/version-share.model';
import { VersionSharesService } from '@core/services/version-shares/version-shares.service';

@Component({
  selector: 'core-helper-box-header-user-date',
  templateUrl: './header-user-date.component.html',
  styleUrls: ['./header-user-date.component.scss']
})
export class HelperBoxHeaderUserDateComponent {
    
    public readonly APPROVAL_STATUS_COLORS = ApprovalStatusColorValues; //['#F6B273','#47B934','#F44848'];
    public readonly FEEDBACK_STATUS_COLORS = FeedbackStatusColorValues;
    // public readonly FEEDBACK_ONLY_COMMENT_COLOR = 'silver';

    @Input() user: any;
    @Input() date: any = null;
    @Input() posText: string;
    @Input() preText: string;
    @Input() feedback:  VersionFeedback = null;
    @Input() versionShares:  Array<VersionShare>;

    constructor(private vsSrv:VersionSharesService){}

    public getBubbleColor(feedback: VersionFeedback){
      if (feedback.approval != null){
          return this.APPROVAL_STATUS_COLORS[feedback.approval.status_code];
      } else {
          return this.FEEDBACK_STATUS_COLORS[feedback.status.status_code];
      }
    }

    public getVersionShareBubbleColor(share: VersionShare) : string {
        return this.vsSrv.getVersionShareBubbleColor(share);
    }

}
